import React from 'react';
import archImg from '../../assets/img/archbtw.png';
import goImg from '../../assets/img/go-logo-white.svg';
import nodeImg from '../../assets/img/node.png';
import reactImg from '../../assets/img/react.png';

export default function WhoAmI() {
  const styles = {
    techStack: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '15px',
      margin: '15px 0'
    },
    techImg: {
      height: '50px',
      width: 'auto',
      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
    }
  };

  return (
    <>
      <section id="who-am-i" data-auto-animate>
        <h1>Présentation</h1>
      </section>

      <section id="who-am-i" data-auto-animate>
        <h1>Présentation</h1>
        <br />

        <h2>Nathan FOURRIER</h2>
        <br />

        <h4>Ingénieur Cybersécurité & Développeur Full-Stack</h4>
        <h4>Freelance</h4>
        <p>
          <strong>ISEN Lille</strong> | <em>Spécialisation informatique</em>
        </p>
        <br />

        <div style={styles.techStack}>
          <img data-src={reactImg} alt="React" style={styles.techImg} />
          <img data-src={nodeImg} alt="Node.js" style={styles.techImg} />
          <img data-src={goImg} alt="Go" style={styles.techImg} />
          <img data-src={archImg} alt="Architecture" style={styles.techImg} />
        </div>
      </section>

      <section id="who-am-i" data-auto-animate>
        <h1>Mon parcours</h1>
        <h3>Formation & Expérience cybersécurité</h3>
        <br />

        <div
          style={{
            textAlign: 'left',
            maxWidth: '800px',
            margin: '0 auto',
            fontSize: '1em'
          }}>
          <h5>
            <span role="img" aria-label="Graduation">
              🎓
            </span>{' '}
            Formation
          </h5>
          <ul style={{ marginBottom: '30px' }}>
            <li>
              <strong>ISEN Lille :</strong> École d'ingénieur, spécialisation
              cybersécurité
            </li>
            <li>
              <strong>6 ans d'alternance :</strong> ArcelorMittal, Veolia, ISEN
            </li>
            <li>
              <strong>Expérience terrain :</strong> Infrastructures critiques
            </li>
          </ul>

          <h5>
            <span role="img" aria-label="Shield">
              🛡️
            </span>{' '}
            Expertise cybersécurité
          </h5>
          <ul>
            <li>
              <strong>2 ans CDI :</strong> Ingénieur sécurité SSII industriels
            </li>
            <li>
              <strong>Freelance :</strong> Consultant cybersécurité
            </li>
            <li>
              <strong>Développement :</strong> Solutions sécurisées
            </li>
          </ul>
        </div>
      </section>
    </>
  );
}
